//
//
//
//
//
//

export default {
    props: {
        step: {
            type: Number,
            default: 0
        }
    },
    computed: {
        classname () {
            return `step-${this.step}`
        }
    },
    methods: {
        changeStep () {
            if (this.step === 1) {
                this.$emit('change', 2)
            } else {
                this.$emit('hide')
            }
        }
    }
}
